import { render } from "./InvoicesDetails.vue?vue&type=template&id=8393a84c&ts=true"
import script from "./InvoicesDetails.vue?vue&type=script&lang=ts"
export * from "./InvoicesDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__